import TreeSelect from '@/components/Select/TreeSelect';
import feedbackPropertyFetcher from '@/features/(charts)/chart-controller/fetchers/useFeedbackPropertyFetcher';
import useTaxonomyStore from '@/stores/TaxonomyStore';

type TaxonomyFilterFieldProps = {
  value: FilterKeyValue[];
  onChange: (value: FilterKeyValue[]) => void;
};

export const TaxonomyFilterField = ({
  value,
  onChange,
}: TaxonomyFilterFieldProps) => {
  const fullTopicMap = useTaxonomyStore((s) => s.fullTopicMap);
  const taxonomyFetcher = feedbackPropertyFetcher.useFetchTaxonomyTree();

  return (
    <TreeSelect
      mode="multiple"
      searchable
      values={value.map((v) => v.filterKey)}
      onChange={(values) => {
        const mapped: FilterKeyValue[] = values.map((alias) => ({
          filterKey: alias,
          filterName: fullTopicMap[String(alias)]?.name ?? String(alias),
        }));
        onChange(mapped);
      }}
      fetcher={taxonomyFetcher}
    />
  );
};
